import { combineReducers } from 'redux';
import { getLocalStorage } from '@/utils/utils';

let weChatInfo = getLocalStorage('weChatInfo');

if (weChatInfo) {
  weChatInfo = JSON.parse(weChatInfo);
}

// 创建一个初始化的state
const initState = {
  lang: getLocalStorage('language') ? getLocalStorage('language') : 'zh-CN',
  sessionId: getLocalStorage('sessionId') ? getLocalStorage('sessionId') : '',
  tempSessionId: getLocalStorage('tempSessionId') ? getLocalStorage('tempSessionId') : '',
  weChatInfo: weChatInfo,
}

function changeLang(state: any = initState, action: any) {
  switch (action.type) {
    case 'CHANGE_LANG':
    return {
      lang: action.lang, // 使用action携带的新name
    }
    default:
    return state  // 没有匹配的action type，返回原来的state
  }
}

function setSessionId(state: any = initState, action: any) {
  switch (action.type) {
    case 'SET_SESSIONID':
    return {
      sessionId: action.sessionId, // 使用action携带的新name
      tempSessionId: action.tempSessionId,
    }
    default:
    return state  // 没有匹配的action type，返回原来的state
  }
}

function setWeChatInfo(state: any = initState, action: any) {
  switch (action.type) {
    case 'SET_WECHAT_INFO':
    return {
      weChatInfo: action.weChatInfo, // 使用action携带的新name
    }
    default:
    return state  // 没有匹配的action type，返回原来的state
  }
}

export default combineReducers({
  changeLang,
  setSessionId,
  setWeChatInfo,
})
